export const dzswtl_wishlistInit = () => {



  jQuery('.dzswtl-for-wishlist-entry').each(function () {
    var _t = jQuery(this);


    if (window.dzswtl_settings && dzswtl_settings.wishlist_ids) {

      if (_t.attr('data-post_id')) {

        if (dzswtl_settings.wishlist_ids.indexOf && dzswtl_settings.wishlist_ids.indexOf(_t.attr('data-post_id')) > -1) {

          if (_t.find('.svg-icon').hasClass('fa-star-o')) {
            _t.find('.svg-icon').eq(0).attr('class', 'svg-icon fa fa-star');

            _t.addClass('wishlist-activated');
          } else {

            _t.find('.svg-icon').eq(0).attr('class', 'svg-icon fa fa-star-o');
            _t.removeClass('wishlist-activated');
          }
        }
      }
    }
  })







  jQuery(document).on('click', ' .dzswtl-wishlist-but', function () {
    var _t = jQuery(this);


    if (_t.hasClass('dzswtl-wishlist-but')) {


      var data = {
        action: 'dzswtl_add_to_wishlist',
        playerid: _t.attr('data-post_id'),
        wishlist_action: 'add',
      };


      if (_t.hasClass('wishlist-activated') || _t.find('.svg-icon').hasClass('fa-star')) {
        data.wishlist_action = 'remove';
      }


      if (window.dzswtl_settings.ajaxurl) {
        jQuery.ajax({
          type: "POST",
          url: window.dzswtl_settings.ajaxurl,
          data: data,
          success: function (response) {


            if(
              _t.hasClass('wishlist-activated')){

              _t.removeClass('wishlist-activated');
            }else{

              _t.addClass('wishlist-activated');
            }
            if (_t.find('.svg-icon').hasClass('fa-star-o')) {
              _t.find('.svg-icon').eq(0).attr('class', 'svg-icon fa fa-star');
            } else {

              _t.find('.svg-icon').eq(0).attr('class', 'svg-icon fa fa-star-o');
            }

          },
          error: function (arg) {

          }
        });
      }

      return false;


    }

  })

}